export const generateId = (): string => {
  const timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
  const oid =
    timestamp +
    "xxxxxxxxxxxxxxxx"
      .replace(/[x]/g, () => ((Math.random() * 16) | 0).toString(16))
      .toLowerCase();

  return oid;
};
